// Pure display helpers shared across pages (no React). Moved out of
// components/ui.tsx so that module exports only components (React Fast Refresh).

/** Shared status → pill-color mapping (corrections / claims / promotions). */
export function statusColor(s: string): string {
  switch (s) {
    case "corrected":
    case "approved":
    case "active":
    case "succeeded":
      return "bg-emerald-500/20 text-emerald-400";
    case "rejected":
    case "failed":
      return "bg-red-500/20 text-red-400";
    case "ignored":
      return "bg-zinc-700 text-zinc-400";
    default:
      return "bg-zinc-700 text-zinc-300";
  }
}

/** Compact relative time ("3m ago"). Promoted from the pipeline nodes. */
export function relTime(iso: string | null | undefined): string {
  if (!iso) return "never";
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return "—";
  const s = Math.max(0, Math.round((Date.now() - then) / 1000));
  if (s < 60) return `${s}s ago`;
  const m = Math.round(s / 60);
  if (m < 60) return `${m}m ago`;
  const h = Math.round(m / 60);
  if (h < 48) return `${h}h ago`;
  return `${Math.round(h / 24)}d ago`;
}
